<template>
  <v-autocomplete
    :item-text="autocompleteItemText"
    flat
    solo
    prepend-inner-icon="fa-search"
    clearable
    hide-no-data
    dense
    outlined
    :filter="filter"
    placeholder=" "
    :items="globalSearchItems"
    :loading="isLoadingSearch"
    :item-value="searchItemIdUniqualizator"
    :search-input.sync="findString"
    :label="$t('common.search')"
    @change="(item) => selectItem(item)"
    return-object
    hide-details
  >
    <template v-slot:prepend>
      <bid-window
          :show="bidWindow.isVisible"
          :bid-id="bidWindow.bidId"
          :customer="bidWindow.customer"
          @hide="bidWindow.isVisible = false; bidWindow.customer = null; bidWindow.bidId=null"
      />
      <v-dialog v-model="customerWin.isVisible" scrollable max-width="890">
        <customerForm
            @removed="customerWin.isVisible=false"
            :is-visible="customerWin.isVisible"
            :customer-id="customerWin.customerId"
        ></customerForm>
      </v-dialog>
      <v-dialog v-model="carWin.isVisible" scrollable max-width="890">
        <carForm :show="carWin.isVisible" @removed="carWin.isVisible=false" :car-id="carWin.carId"></carForm>
      </v-dialog>
      <order-window
          :is-visible="orderWindow.isVisible"
          :order-id="orderWindow.orderId"
          @hide="orderWindow.orderId=null; orderWindow.isVisible=false;"
      />
    </template>
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title
          >{{ autocompleteItemText(item) }}
          <beauty-car-number
            v-if="autocompleteCarNumber(item)"
            :number="autocompleteCarNumber(item)"
            class="d-inline-block beauty-car-number"
          />
        </v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>

</template>

<script>
import { mapFields } from "vuex-map-fields";
import BeautyCarNumber from "@/components/common/BeautyCarNumber";
import BidWindow from "@/components/bid/BidWindow";
import CustomerForm from "@/components/customer/CustomerForm";
import CarForm from "@/components/garage/CarForm";
import OrderWindow from "@/components/order/OrderWindow.vue";
import CommonMixin from "@/mixins/common";

export default {
  name: "GlobalSearch",
  components: {OrderWindow, CarForm, CustomerForm, BidWindow, BeautyCarNumber },
  data: () => ({
    findString: null,
    findTimeoutId: null,
    noData: true,
    customerWin:{
      customerId:null,
      isVisible: false,
    },
    bidWindow: {
      isVisible: false,
      customer: null,
      bidId: null
    },
    carWin:{
      isVisible: false,
      carId: null,
    },
    orderWindow: {
      orderId: null,
      isVisible: false
    }

  }),
  mixins: [CommonMixin],
  computed: {
    ...mapFields("common", ["globalSearchItems", "isLoadingSearch"]),
    ...mapFields("garage", ["carFormTabsId",]),
    items() {
      return [];
    },
  },
  watch: {
    findString() {
      if (this.findString === "" || this.findString === null) {
        clearTimeout(this.findTimeoutId);
        return;
      }
      clearTimeout(this.findTimeoutId);
      this.findTimeoutId = setTimeout(() => {
        this.$store.dispatch("common/globalSearch", this.findString);
      }, 1000);
    },
  },
  methods: {
    //v-autocomplete без этой функции не показывает все найденные элементы
    searchItemIdUniqualizator(item){
      return item.disabled ? item.title : item.type + '_' + item.id;
    },
    selectItem(item) {

      switch (item.type){
        case 'customer_car':
          this.carFormTabsId = 0;
          this.carWin.carId = item.id;
          this.carWin.isVisible = true;
          break;
        case 'customer':
          this.customerWin.customerId = item.id;
          this.customerWin.isVisible = true;
          break;
        case 'bid':
          this.bidWindow.customer = item.customer;
          this.bidWindow.bidId = item.id;
          this.bidWindow.isVisible = true;
          break;
        case 'order':
          this.orderWindow.isVisible = true;
          this.orderWindow.orderId = item.id;
          break;
      }

      this.globalSearchItems = [];
      this.$nextTick(() => {
        this.findString = "";
      });
    },
    filter(item, queryText, itemText) {
      return true;
    },
    autocompleteItemText(item) {
      let date = null;
      switch (item.type) {
        case "customer":
          let car = "";
          let vin = "";
          car =
            item.cars &&
            item.cars.filter((it) => it.vin === this.findCustomerString);
          if (car && car[0]) {
            vin = "/" + car[0]["vin"] + " " + car[0]["name"] + "/";
          }
          return `[#${item.human_number}] ${vin} ${item.full_name} (${
            item.phone
          }) [${this.$moment(item.created_at).format("DD.MM.YYYY HH:mm")}]`;

        case "customer_car":

          let car_title =
            item.brand + " " + item.family + " " + item.model !== item.name
              ? item.brand +
                " " +
                item.family +
                " " +
                item.model +
                "(" +
                item.name +
                ")"
              : item.name;
            let customer_name = item.customer && item.customer.full_name || false;
          customer_name = customer_name ? ` (${customer_name})` : '';
          return car_title + customer_name;

        case "order":
          date = this.$moment(item.created_at).format("DD.MM.YYYY HH:mm");
          return `#${item.human_number} (${this.formatCurrency(item.total_sum)}) ${item.customer.full_name} [${date}]`;

        case "bid":
          date = this.$moment(item.created_at).format("DD.MM.YYYY HH:mm");
          let name = item.customer
            ? item.customer.full_name
            : item.customer_name;
          return `${name || ""} [${date}]`;
      }
      return this.$t("common." + item.title);
    },
    autocompleteCarNumber(item) {
      switch (item.type) {
        case "customer":
          return false;

        case "order":
          return (item.car && item.car.car_number) || false;

        case "customer_car":
          return item.car_number || false;

        case "bid":
          return (item.car && item.car.car_number) || item.car_number || false;
      }
      return false;
    },
  },
};
</script>

<style scoped></style>
